import { obtenerUsuariosDelAlcance, obtenerPerfilActual } from './eventAccess';
import { normalizarUsuarioOperativo, usuarioValidoParaAtribucion } from './identidadOperativa';

export async function obtenerRelacionadoresEvento(evento, modulo, accesoActual = null) {
  if (!evento?.id || !evento?.empresaId) return [];
  const acceso = accesoActual || await obtenerPerfilActual();
  const usuarios = await obtenerUsuariosDelAlcance(acceso);
  return usuarios.map((p) => normalizarUsuarioOperativo(p)).filter((p) => usuarioValidoParaAtribucion(p, evento, modulo))
    .sort((a, b) => a.nombre.localeCompare(b.nombre, 'es') || a.id.localeCompare(b.id));
}
